import { Carousel } from '@mantine/carousel';
import { Image, createStyles } from '@mantine/core';
import style from './carouselCompoStyle.module.css';

const useStyles = createStyles((theme) => ({
  control: {
    backgroundColor: '#F2EEC8',
    borderColor: '#F2EEC8',
    color: '#F56600',
    opacity: 1,
  },
}));

const CarouselCompo = (props) => {
  const { property } = props;
  const { classes } = useStyles();
  return (
    <Carousel
      controlsOffset="10%"
      controlSize={40}
      height={200}
      slideSize="33.333333%"
      slideGap="sm"
      breakpoints={[
        { maxWidth: 'md', slideSize: '50%' },
        { maxWidth: 'sm', slideSize: '100%', slideGap: 0 },
      ]}
      align="start"
      classNames={{
        control: classes.control,
      }}
      styles={{
        control: {
          '&[data-inactive]': {
            opacity: 0.5,
            cursor: 'default',
          },
        },
      }}
    >
      {property?.images?.map((item, key) => {
        return (
          <Carousel.Slide key={key} className={style['mantine-mkghez']}>
            <Image src={item} withPlaceholder />
          </Carousel.Slide>
        );
      })}
      {/* ...other slides */}
    </Carousel>
  );
};

export default CarouselCompo;
